import { render } from "./PreviewBlock.vue?vue&type=template&id=6da33e86&scoped=true"
import script from "./PreviewBlock.vue?vue&type=script&lang=js"
export * from "./PreviewBlock.vue?vue&type=script&lang=js"

import "./PreviewBlock.vue?vue&type=style&index=0&id=6da33e86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da33e86"]])

export default __exports__